import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import { Anchorme } from 'react-anchorme'
import { toUserTimezone, getInitials, getFullName } from 'utils';
import getPlainText from 'utils/mention-to-plaintext';
import { Link } from 'react-router-dom';
import MessageAttachment from "./MessageAttachment";

const displayTransform = (id, display) => '@' + display;

const useStyles = makeStyles((theme) => ({
  bubbleSelf: {
    'marginLeft': '10%',
    'marginBottom': 24,
    '& .content': {
      flex: 1,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderRadius: 12,
      padding: 10,
      marginRight: 8,
      whiteSpace: 'pre-wrap'
    },
    '& .header': {
      marginBottom: 4,
    },
    '& a': {
      color: 'white',
      textDecoration: 'underline'
    }
  },
  bubbleOther: {
    'marginRight': '10%',
    'marginBottom': 24,
    'backgroundColor': 'white',
    '& .header': {
      display: 'flex',
      justifyContent: 'space-between',
      marginLeft: theme.spacing(6),
    },
    '& .content': {
      flex: 1,
      backgroundColor: '#E8EBF1',
      borderRadius: 8,
      padding: 10,
      marginLeft: 8,
      whiteSpace: 'pre-wrap'
    },
  },
  author: {
    fontWeight: 500,
  },
  ts: {
    textAlign: 'right',
  },
  avatar: {
    marginBottom: 8,
  },
}));

const TextMessage = ({ message, user }) => {
  const classes = useStyles();
  const isSelf = user.id === message.user.user_id;
  const isStudent = message.user.user_type === 'student';
  const avatar = (
    <Avatar className={classes.avatar} src={message.user.avatar}>
      {getInitials(message.user.user_first_name, message.user.user_last_name)}
    </Avatar>
  );

  return (
    <div className={isSelf ? classes.bubbleSelf : classes.bubbleOther}>
      <div className="header">
        {!isSelf && isStudent && (
          <Link
            className={classes.link}
            to={`/students/${message.user.user_id}/timeline`}
          >
            <Typography
              color="textPrimary"
              gutterBottom
              variant="caption"
              className={classes.author}
            >
              {getFullName(message.user)}
            </Typography>
          </Link>
        )}
        {!isSelf && !isStudent && (
          <Typography gutterBottom variant="caption" className={classes.author}>
            {getFullName(message.user)}
          </Typography>
        )}
        {isSelf && <span />}
        <Typography
          className={classes.ts}
          variant="caption"
          color="textSecondary"
        >
          {toUserTimezone(message.created_at, user.timezone).format('LLL')}
        </Typography>
      </div>
      <Box display="flex" alignItems="flex-end">
        {!isSelf && !isStudent && avatar}
        {!isSelf && isStudent && (
          <Link
            className={classes.link}
            to={`/students/${message.user.user_id}/timeline`}
          >
            {avatar}
          </Link>
        )}
        <div className="content">
          <Typography gutterBottom color="inherit" variant="body2">
            <Anchorme target="_blank" rel="noreferrer noopener">
              {getPlainText(message.text, displayTransform).join('')}
            </Anchorme>
          </Typography>
          { message.attachment && <MessageAttachment fileKey={message.attachment} />}
        </div>
        {isSelf && avatar}
      </Box>
    </div>
  );
};

export default TextMessage;
